import lodash from 'lodash'
import React, { ReactElement } from 'react'

import Checkbox from '../../../../../../../../1stlog-ui/src/components/Checkbox'
import Field from '../../../../../../../../1stlog-ui/src/components/Field'

const typeMap = {
  email: i18n.t('email', 'E-Mail'),
  sms: i18n.t('sms', 'SMS'),
}

type TTypeSelectProps = {
  type: string
}

const TypeSelect = (props: TTypeSelectProps): ReactElement => {
  const { type } = props

  return (
    <div className="mr-2">
      <Field name={type} noMargin>
        <Checkbox block iconTooltip={undefined}>
          {lodash.get(typeMap, type)}
        </Checkbox>
      </Field>
    </div>
  )
}

export default TypeSelect
